// extracted by mini-css-extract-plugin
export var carrierNotice = "_km-5";
export var carrierNoticePlaceholder = "_km-6";
export var deliveryRow = "_km-c";
export var fixedHeight = "_km-4";
export var freightLogo = "_km-b";
export var fullWidth = "_km-3";
export var priceColumn = "_km-7";
export var radioSelected = "_km-9";
export var radioUnselected = "_km-8";
export var selectedOption = "_km-2";
export var selectedOptionContainer = "_km-1";
export var selection = "_km-0";
export var tallSkeletonText = "_km-a";